import { useMutation } from '@apollo/client';
import { useCallback } from 'react';

import { UpdateUserPhoneMutation, UpdateUserPhoneMutationVariables } from '../../types';
import { UPDATE_USER_PHONE } from './updateUserPhone';

type UseUpdateUserPhoneResponse = {
  loading: boolean;
  handleUpdateUserPhone: (id: string, phone: string) => Promise<void>;
};

const useUpdateUserPhone = (): UseUpdateUserPhoneResponse => {
  const [updateUserPhone, { loading }] = useMutation<UpdateUserPhoneMutation, UpdateUserPhoneMutationVariables>(
    UPDATE_USER_PHONE
  );

  const handleUpdateUserPhone = useCallback(
    async (id: string, phone: string): Promise<void> => {
      await updateUserPhone({
        variables: {
          id,
          phone,
        },
      });
    },
    [updateUserPhone]
  );
  return {
    loading,
    handleUpdateUserPhone,
  };
};

export default useUpdateUserPhone;
